Controller = App.loadClass 'core::Angular/Controller'

class exports.BaseMachineryController extends Controller
    constructor: (@scope, @transitions, @modal, @machineryService, @q, @viewing, @editing, @id, @typeId) ->
        super @scope, @transitions

        # Form controller
        @machineryForm = {}

        if @editing
            unregister = @scope.$watch () =>
                return @machineryForm
            , (form) =>
                if form.proprietary_format? and (@machinery.type.name isnt 'Planter' or form.crop?)
                    @dirtyCropAndFormat()
                    unregister()
            , true

        @scope.cancel = @cancel.bind this

        # This could maybe go backend? In the database?
        @subtypeFilters = {
            'Corn': [
                'Planter'
            ],
            'Small Grains': [
                'Air Seeder'
                'Planter'
                'Drill'
                'Broadcast'
            ],
            'Soybeans': [
                'Air Seeder'
                'Planter'
                'Drill'
                'Broadcast'
            ],
            'Cotton': [
                'Planter'
            ],
        }

        @seedMeterFilters = {
            'Air Seeder': [
                'Paddle'
            ],
            'Broadcast': [
                'Paddle'
            ],
            'Drill': [
                'Paddle'
            ],
            'Planter': [
                'Air'
                'Belt'
                'Brush'
                'Finger'
                'Plate'
            ],
        }

        # Form data
        @formData = {
            makes: []
            models: []
            subtypes: []
        }
        @machinery = @machineryService.new
            type: null
            insecticide: false
            twin_rows: false
            variable_rate: false
            used_for_fertilizer: false
        @nicknameIsUnique = true

        # Load Data
        # Edit
        if @id?
            @machineryService.getType(@typeId).then (type) =>
                @machinery.type = type
                @loadFormData @id
        # New
        else
            @machineryService.getTypes().then (types) =>
                @types = types

        @scope.$watch '[emc.machinery.swath_width, emc.machinery.row_spacing]', () =>
            return unless @machinery.seed_meter is 'Paddle'

            # Metric uses meters and centimeters
            if App.is_metric
                ratio = 100
            # English uses feet and inches
            else
                ratio = 12
            @machinery.number_of_rows = Math.ceil (@machinery.swath_width * ratio) / @machinery.row_spacing

    dirtyCropAndFormat: () =>
        @machineryForm.crop?.$setDirty()
        @machineryForm.proprietary_format?.$setDirty()

    startEditing: () =>
        @viewing = false
        @editing = true
        if @machineryForm.proprietary_format? and (@machinery.type.name isnt 'Planter' or @machineryForm.crop?)
            @dirtyCropAndFormat()

    # Load need form options
    loadFormData: (id = null) ->
        @machineryService.getFormData(@machinery).then (data) =>
            angular.extend @formData, data
            @clearAlert()
            @loadMachineryData id
            .then () =>
                @machineryService.getSubtypes @machinery.type
                .then (subtypes) =>
                    @formData.subtypes = subtypes

                # If not editing don't get other dropdown contents yet
                return if not id?

                if @machinery.subtype
                    @machineryService.getMakes @machinery.type, @machinery.subtype
                    .then (makes) =>
                        @formData.makes = makes

                    if @machinery.make
                        @machineryService.getModels @machinery.type, @machinery.subtype, @machinery.make
                        .then (models) =>
                            @formData.models = models

                    if @machinery.variable_rate
                        @machineryService.getControllerMakes()
                        .then (makes) =>
                            @formData.controllerMakes = makes
                        @machineryService.getControllerModels @machinery.controller_make
                        .then (models) =>
                            @formData.controllerModels = models
                        @machineryService.getProprietaryFormats @machinery.controller_make, @machinery.controller_model
                        .then (formats) =>
                            @formData.proprietaryFormats = formats
        .catch (error) =>
            # TODO: clean up for better user errors
            console.error error
            if error instanceof Error
                @setAlert
                    msg: error.toString()
                    type: 'error'
                , [
                    error.stack
                ]
            else
                @setAlert
                    msg: error.statusText
                    type: 'error'

    # Load machinery to be edited
    loadMachineryData: (id = null) =>
        # if there is a machinery to load do so
        if id?
            return @machineryService.getMachinery(@machinery.type, id).then (machinery) =>
                @clearAlert()
                @machinery = machinery
        else
            # else set defaults
            @machinery.insecticide = false
            @machinery.twin_rows = false
            @machinery.variable_rate = false
            @machinery.used_for_fertilizer = false
            return @q.resolve()


    # Save Machinery
    save: () ->
        @setAlert
            msg: 'Saving machinery...'
            type: 'info'

        @machineryService.save @machinery
        .then (machine) =>
            @setAlert
                msg: "#{@machinery.type.name} saved!"
                type: 'success'
        .catch (error) =>
            @setAlert
                msg: error
                type: 'error'

    cancel: () -> undefined

    ##########
    # Events #
    ##########

    onTypeChange: () ->
        @machinery = @machineryService.new
            type: @machinery.type
            insecticide: false
            twin_rows: false
            variable_rate: false
            used_for_fertilizer: false

        if @machinery.type?
            @loadFormData().then () =>
                @machineryForm.subtype?.$setPristine()

    onCropChange: () ->
        @machinery.subtype = @machinery.make = @machinery.model = @machinery.seed_meter = null
        @machineryForm.subtype.$setPristine()
        @machineryForm.make.$setPristine()
        @machineryForm.model.$setPristine()

    validateNickname: (name) ->
        return @machineryService.validateNickname @machinery, name

    onSubtypeChange: (val) ->
        if @machinery.type.name is 'Planter'
            @machinery.seed_meter = null
        @machinery.fertilizer_source_type = @machinery.make = @machinery.model = null
        @machineryForm.make.$setPristine()
        @machineryForm.model.$setPristine()
        return if not @machinery.subtype?

        if @machinery.subtype
            @machineryService.getMakes @machinery.type, @machinery.subtype
            .then (makes) =>
                @formData.makes = makes

    onMakeChange: () ->
        @machinery.model = null
        @machineryForm.model.$setPristine()
        return if not @machinery.make?
        @machineryService.getModels @machinery.type, @machinery.subtype, @machinery.make
        .then (models) =>
            @formData.models = models

    onVariableRateChange: () ->
        @machinery.controller_make = null
        @machineryForm.display_make.$setPristine()
        @onControllerMakeChange()
        return if not @machinery.variable_rate
        @machineryService.getControllerMakes()
        .then (makes) =>
            @formData.controllerMakes = makes

    onControllerMakeChange: () ->
        @machinery.controller_model = null
        @machinery.rx_naming_format = null
        @machineryForm.display_model.$setPristine()
        @machineryForm.proprietary_format.$setPristine()
        return if not @machinery.controller_make?
        @machineryService.getControllerModels @machinery.controller_make
        .then (models) =>
            @formData.controllerModels = models
            if models.length is 1
                @machinery.controller_model = models[0]
                @onControllerModelChange()

    onControllerModelChange: () ->
        @machinery.rx_naming_format = null
        @machineryForm.proprietary_format.$setPristine()
        return if not @machinery.controller_model?
        @machineryService.getProprietaryFormats @machinery.controller_make, @machinery.controller_model
        .then (formats) =>
            @formData.proprietaryFormats = formats
            if formats.length is 1
                @machinery.rx_naming_format = formats[0]

    filterSubtypes: (thing) =>
        if @machinery.type?.name is 'Planter' and @machinery.crop?
            return thing.name in @subtypeFilters[@machinery.crop.name]
        return true

    filterSeedMeters: (thing) =>
        if @machinery.type?.name is 'Planter' and @machinery.subtype?
            return thing in @seedMeterFilters[@machinery.subtype.name]
        return true



    addMake: (makeName) ->
        @machinery.make = null
        @machinery.model = null
        @formData.models = []
        @addMakeModel makeName, ''

    addModel: (modelName) ->
        @machinery.model = null
        @addMakeModel '', modelName

    # Create scope and load Add Make Dialog
    addMakeModel: (makeName, modelName) =>
        newscope = @scope.$new(true)
        newscope.make = @machinery.make or new @machineryService.Make
            name: makeName
        newscope.make.subtype = @machinery.subtype
        newscope.make.subtype.type = @machinery.type
        newscope.model = new @machineryService.Model
            name: modelName
            make: newscope.make
        newscope.title = 'Add Make/Model'
        newscope.type = ''
        newscope.saveText = 'Save'

        # Ensures make is unique
        newscope.validateMake = (name) =>
            if not name or newscope.make.id
                return true
            return @machineryService.validateMake @machinery.type, @machinery.subtype, name

        # Ensures model is unique
        newscope.validateModel = (name) =>
            if not name or not newscope.make.id?
                return true
            return @machineryService.validateModel @machinery.type, @machinery.subtype, @machinery.make, name

        parent = this
        newscope.saveMakeModel = () ->
            @setAlert
                msg: 'Saving...'
                type: 'info'
            makePromise = Promise.resolve newscope.make
            if not newscope.make.id?
                makePromise = parent.machineryService.saveMake newscope.make
                    .then (make) =>
                        # add to make to form and select make
                        parent.formData.makes.push make
                        parent.machinery.make = make
                        parent.machineryForm.make.$setDirty()
                    .catch (error) =>
                        @setAlert
                            type: 'error'
                            msg: error
            return makePromise.then () =>
                parent.machineryService.saveModel newscope.model
                    .then (model) =>
                        # add to model to form and select model
                        parent.formData.models.push model
                        parent.machinery.model = model
                        parent.machineryForm.model.$setDirty()
                        @closeWithAlert
                            type: 'success'
                            msg: 'Make/Model created successfully.'
                    .catch (error) =>
                        @setAlert
                            type: 'error'
                            msg: error

        # Open the dialog
        @openDialog(newscope, 'backend/grower/machinery/layout-add-make-model')

    # Create scope and load Add Display Make Dialog
    addDisplayMakeModel: () =>
        newscope = @scope.$new(true)
        newscope.make = @machinery.controller_make or new @machineryService.ControllerMake
            name: ''
        newscope.model = new @machineryService.ControllerModel
            name: ''
            controller_make: newscope.make
        newscope.title = 'Request Display Support'
        newscope.type = 'Display'
        newscope.saveText = 'Submit'
        newscope.text = 'To send MyFarms an email requesting support for a display that is not currently available,
                         please fill out this form and click Submit.'

        newscope.validateMake = newscope.validateModel = (name) =>
            return true
        parent = this
        newscope.saveMakeModel = () ->
            @setAlert
                msg: 'Saving...'
                type: 'info'
            return parent.machineryService.requestController newscope.make, newscope.model
                .then () =>
                    # add to model to form and select model
                    @closeWithAlert
                        type: 'success'
                        msg: 'Your request has been successfully submitted for future consideration.'
                .catch (error) =>
                    @setAlert
                        type: 'error'
                        msg: error

        @openDialog(newscope, 'backend/grower/machinery/layout-add-make-model')

    addRowSpacing: (rowSpacing) =>
        newscope = @scope.$new(true)
        newscope.title = 'Add Row Spacing'
        newscope.rowSpacing = new @machineryService.RowSpacing
            width: parseInt rowSpacing

        # Ensures model is unique
        newscope.validateRowSpacing = (width) =>
            return @machineryService.validateRowSpacing(width)

        parent = this
        # Custom save function
        newscope.saveRowSpacing = () ->
            @setAlert
                msg: 'Saving Model...'
                type: 'info'
            return parent.machineryService.createRowSpacing newscope.rowSpacing
                .then (rowSpacing) =>
                    # add to model to form and select model
                    parent.formData.rowSpacings.push rowSpacing.formatted_width
                    parent.machinery.row_spacing = rowSpacing.formatted_width
                    parent.machineryForm.row_spacing.$setDirty()
                    @closeWithAlert
                        type: 'success'
                        msg: 'Row Spacing created successfully.'
                .catch (error) =>
                    @setAlert
                        type: 'error'
                        msg: error

        @openDialog(newscope, 'backend/grower/machinery/layout-add-row-spacing')


    openDialog: (newscope, url) =>
        newscope.name = ''

        dlg = @modal.open
            templateUrl: url
            controller: 'DialogController'
            windowClass: 'small_dialog'
            scope: newscope
